export const Errors = {
  Unauthorized: 1401
} as const;
